import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { Link } from 'react-router-dom';
import React from 'react';

const Footer = () => {
	const currentYear = new Date()?.getFullYear();

	const practiceAreas = [
		'Corporate Law',
		'Personal Injury',
		'Criminal Defense',
		'Family Law',
		'Real Estate Law',
		'Employment Law',
		'Intellectual Property',
		'Estate Planning',
	];

	const quickLinks = [
		{ name: 'About Us', path: '/about' },
		{ name: 'Our Attorneys', path: '/attorneys' },
		{ name: 'Practice Areas', path: '/practice-areas' },
		{ name: 'Publications', path: '/publications' },
		{ name: 'Contact', path: '/contact' },
		{ name: 'Careers', path: '/careers' },
	];

	const contactInfo = [
		{
			icon: 'MapPin',
			title: 'Main Office',
			details: [
				'No 108 Ada George Road',
				'Chinda Junction Mile 4',
				'Port Harcourt, Rivers State',
				'Nigeria',
			],
		},
		{
			icon: 'Phone',
			title: 'Phone',
			details: ['(+234) 909-552-9557'],
		},
		{
			icon: 'Mail',
			title: 'Email',
			details: ['info@fepalawpartners.com'],
		},
	];

	const socialLinks = [
		{ name: 'LinkedIn', icon: 'Linkedin', url: '#' },
		{ name: 'Twitter', icon: 'Twitter', url: '#' },
		{ name: 'Facebook', icon: 'Facebook', url: '#' },
		{ name: 'YouTube', icon: 'Youtube', url: '#' },
	];

	return (
		<footer className='bg-primary text-white'>
			{/* Main Footer Content */}
			<div className='py-16'>
				<div className='max-w-7xl mx-auto px-4 lg:px-8'>
					<div className='grid grid-cols-1 lg:grid-cols-4 gap-12'>
						{/* Company Info */}
						<div className='lg:col-span-1'>
							<Link to='/homepage' className='flex items-center mb-6'>
								<div className='relative'>
									<Image
										src='/assets/images/logo.png'
										alt='Fepa Law Partners Logo'
										className='w-32 h-32 object-contain drop-shadow-lg'
									/>
								</div>
							</Link>

							<p className='font-source text-white/80 leading-relaxed mb-6'>
								Fepa Law Partners represents the pinnacle of legal excellence in Nigeria, combining
								sophisticated expertise with unwavering commitment to client success. When stakes
								are highest, choose the firm that delivers results.
							</p>

							<div className='flex space-x-4'>
								{socialLinks?.map((social) => (
									<a
										key={social?.name}
										href={social?.url}
										className='w-10 h-10 bg-white/10 hover:bg-accent hover:text-primary rounded-lg flex items-center justify-center transition-all duration-300'
										aria-label={social?.name}
									>
										<Icon name={social?.icon} size={20} />
									</a>
								))}
							</div>
						</div>

						{/* Practice Areas */}
						<div>
							<h3 className='font-playfair font-semibold text-xl text-white mb-6'>
								Practice Areas
							</h3>
							<ul className='space-y-3'>
								{practiceAreas?.map((area) => (
									<li key={area}>
										<Link
											to='/practice-areas'
											className='font-source text-white/80 hover:text-accent transition-colors duration-300 flex items-center group'
										>
											<Icon
												name='ChevronRight'
												size={16}
												className='mr-2 group-hover:translate-x-1 transition-transform duration-300'
											/>
											{area}
										</Link>
									</li>
								))}
							</ul>
						</div>

						{/* Quick Links */}
						<div>
							<h3 className='font-playfair font-semibold text-xl text-white mb-6'>Quick Links</h3>
							<ul className='space-y-3'>
								{quickLinks?.map((link) => (
									<li key={link?.name}>
										<Link
											to={link?.path}
											className='font-source text-white/80 hover:text-accent transition-colors duration-300 flex items-center group'
										>
											<Icon
												name='ChevronRight'
												size={16}
												className='mr-2 group-hover:translate-x-1 transition-transform duration-300'
											/>
											{link?.name}
										</Link>
									</li>
								))}
							</ul>

							<div className='mt-8'>
								<Link to='/contact'>
									<Button
										variant='default'
										className='bg-accent hover:bg-accent/90 text-primary font-source font-semibold w-full'
										iconName='Calendar'
										iconPosition='left'
										iconSize={18}
									>
										Schedule a Consultation
									</Button>
								</Link>
							</div>
						</div>

						{/* Contact Info */}
						<div>
							<h3 className='font-playfair font-semibold text-xl text-white mb-6'>
								Contact Information
							</h3>
							<div className='space-y-6'>
								{contactInfo?.map((contact, index) => (
									<div key={index} className='flex items-start space-x-3'>
										<div className='w-10 h-10 bg-accent/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1'>
											<Icon name={contact?.icon} size={20} color='var(--color-accent)' />
										</div>
										<div>
											<h4 className='font-source font-semibold text-white mb-1'>
												{contact?.title}
											</h4>
											{contact?.details?.map((detail, idx) => (
												<p key={idx} className='font-source text-white/80 text-sm'>
													{detail}
												</p>
											))}
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Bottom Bar */}
			<div className='border-t border-white/10'>
				<div className='max-w-7xl mx-auto px-4 lg:px-8 py-6'>
					<div className='flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0'>
						<div className='flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6'>
							<p className='font-source text-white/80 text-sm'>
								© {currentYear} Fepa Law Partners. All rights reserved.
							</p>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
